var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeIcon = function SvgEyeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M12.01 16C6.945 16 2.424 11.789 0 7.576 2.418 3.473 6.943 0 12.01 0c5.135 0 9.635 3.453 11.999 7.564C21.768 11.994 17.283 16 12.01 16M1.168 7.584C2.011 8.915 6.186 15 12.01 15c6.305 0 10.112-6.103 10.851-7.405C22.089 6.397 18.255 1 12.01 1 5.894 1 1.985 6.355 1.168 7.584M12 3c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0 1c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4",
    clipRule: "evenodd"
  })));
};
export default SvgEyeIcon;